import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SignInRoutingModule} from './sign-in-routing.module';
import {SignInComponent} from './components/sign-in/sign-in.component';
import {CommonMaterialModule} from '../../shared/modules/common-material.module';
import {CommonFormModule} from '../../shared/modules/common-form.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    SignInRoutingModule,
    CommonMaterialModule,
    CommonFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    TranslateModule
  ],
  declarations: [SignInComponent]
})
export class SignInModule {
}
